/** @deprecated */
export {MdProgressSpinner as MdProgressCircle} from './progress-spinner';
/** @deprecated */
export {MdProgressSpinnerModule as MdProgressCircleModule} from './progress-spinner';
